<template>
    <div id="category-selector-outer">
        <div
            id="category-selector-inner"
            class="flex flex-wrap gap-2 overflow-hidden bg-gray-200 lg:bg-white"
        >
            <template class="" v-if="deepSelectedCategory">
                <div
                    @click="selectCategory(deepSelectedCategory.id)"
                    :class="getCategoryCss(deepSelectedCategory.id)"
                >
                    <div class="category-button">
                        {{ deepSelectedCategory.title }}
                    </div>
                    <div class="">
                        {{
                            Math.round(
                                deepSelectedCategory.student_average * 100
                            )
                        }}%
                    </div>
                </div>
            </template>
            <template v-for="(category, index) in categories">
                <div
                    @click="selectCategory(category.id)"
                    :class="getCategoryCss(category.id)"
                    v-if="
                        index < showCategoryCount &&
                        category !== deepSelectedCategory
                    "
                >
                    <div class="category-button">
                        {{ category.title }}
                    </div>
                    <div class="">{{ Math.round(category.avg * 100) }}%</div>
                </div>
            </template>
        </div>
    </div>
    <div v-if="hiddenCategoryCount">
        <new-modal title="Filter by category">
            <template #trigger>
                <div
                    v-if="hiddenCategoryCount >= 1"
                    class="px-0 py-3 text-[15px] font-semibold text-primary-525 hover:cursor-pointer hover:text-primary-600"
                >
                    See All (+ {{ hiddenCategoryCount }})
                </div>
            </template>
            <template #content>
                <div class="flex flex-col gap-2">
                    <template v-for="(category, index) in categories">
                        <div
                            @click="selectCategory(category.id)"
                            class="flex items-center justify-between gap-4 tracking-tight text-gray-700"
                        >
                            <div class="category-button">
                                <text-clamp
                                    autoResize
                                    :max-lines="1"
                                    :text="category.title"
                                />
                            </div>
                            <div class="w-16 flex-none">
                                <student-score-box
                                    :percent-average="category.avg"
                                ></student-score-box>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </new-modal>
    </div>
</template>
<script>
import NewModal from "@/Components/NewModal.vue";
import StudentScoreBox from "@/Components/StudentScoreBox.vue";

export default {
    name: "StudentMobileCategorySelector",
    emits: ["category-selected"],
    components: { StudentScoreBox, NewModal },
    props: {
        categories: {},
        initSelectedCategory: {},
    },
    data() {
        return {
            selectedCategory: this.initSelectedCategory,
            deepSelectedCategory: null,
            showCategoryCount: 3,
        };
    },
    methods: {
        getCategoryCss(categoryId) {
            let css =
                "border border-gray-325 hover:cursor-pointer hover:bg-gray-325 font-medium text-[14px] rounded-full gap-2 px-2 py-1 flex w-auto inline-block items-center whitespace-nowrap";

            if (this.selectedCategory.id === categoryId) {
                css += " " + "bg-gray-900 text-white";
            }

            return css;
        },
        selectCategory(categoryId) {
            this.$emit("category-selected", categoryId);
        },
        getDeepSelectedCategory() {
            let vm = this;
            let selectedCategoryIndex = _.findIndex(
                vm.categories,
                function (category) {
                    return category.id === vm.initSelectedCategory.id;
                }
            );

            if (selectedCategoryIndex > vm.showCategoryCount) {
                vm.deepSelectedCategory = vm.categories[selectedCategoryIndex];
            }
        },
        updatePageView() {
            if (window.innerWidth > 550) {
                this.showCategoryCount = 7;
            } else {
                this.showCategoryCount = 3;
            }
            this.getDeepSelectedCategory();
        },
    },
    computed: {
        hiddenCategoryCount() {
            return (
                this.categories.length -
                this.showCategoryCount +
                (this.deepSelectedCategory ? -1 : 0)
            );
        },
    },
    mounted() {
        this.getDeepSelectedCategory();

        this.updatePageView();

        this.$nextTick(() => {
            window.addEventListener("resize", this.updatePageView);
        });
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.updatePageView);
    },
};
</script>
